import React from 'react';
import {makeStyles, Divider} from '@material-ui/core';
import {Section, SectionAlternate} from 'components/organisms';
import {GetStarted, Features, Reviews, Difference, Problems, Hero, Solution} from './components';
import ContactDialog from "../ContactDialog";

const useStyles = makeStyles(() => ({
    sectionAlternateNoPaddingTop: {
        '& .section-alternate__content': {
            paddingBottom: 0,
        },
    },
    dividerSection: {
        paddingTop: 0,
        paddingBottom: 0,
    },
}));

const IndexView = () => {
    const classes = useStyles();
    const [showContact, setShowContact] = React.useState(false);
 
    return (
       <div>
           <Hero onContact={()=>setShowContact(true)}/>
           <SectionAlternate>
               <Problems/>
           </SectionAlternate>
           <Section>
               <Solution/>
           </Section>
           <SectionAlternate className={classes.sectionAlternateNoPaddingTop}>
               <Features/>
           </SectionAlternate>
           <Section>
               <Difference onContact={()=>setShowContact(true)}/>
           </Section>
           <Section className={classes.dividerSection}>
               <Divider/>
           </Section>
           <SectionAlternate>
               <GetStarted/>
           </SectionAlternate>
           <ContactDialog open={showContact}
                          onClose={() => setShowContact(false)}/>
       </div>
    );
};

export default IndexView;
